import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  sort: {
    brandClasses: {
      container: 'b-b center h-6',
      icon: 'ml-1',
      text: 'text-sm'
    }
  }
} satisfies RecursivePartial<VfConfig['select']>
